"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.UpdateNestedProperty = exports.OverrideMergeObjects = exports.ObjectsAreTheSame = exports.MakeInheritanceObject = exports.IsAnObject = exports.DeepMergeObjects = exports.CreateCompareValueOverride = void 0;
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.array.sort.js");
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/web.dom-collections.iterator.js");
const ObjectsAreTheSame = (obj1, obj2) => {
  const JsonStringifySorted = obj => {
    const keys = {};
    JSON.stringify(obj, (key, value) => {
      keys[key] = null;
      return value;
    });
    return JSON.stringify(obj, Object.keys(keys).sort());
  };
  return JsonStringifySorted(obj1) === JsonStringifySorted(obj2);
};
exports.ObjectsAreTheSame = ObjectsAreTheSame;
const IsAnObject = value => value && !Array.isArray(value) && typeof value === 'object';
exports.IsAnObject = IsAnObject;
const CreateCompareValueOverride = (key, compareValue) => "".concat(key, ":").concat(JSON.stringify(compareValue));
exports.CreateCompareValueOverride = CreateCompareValueOverride;
const DeepMergeObjects = _ref => {
  let {
    baseObject,
    overrideObject
  } = _ref;
  const mergeDeep = function mergeDeep() {
    for (var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++) {
      objects[_key] = arguments[_key];
    }
    return objects.reduce((prev, obj) => {
      Object.keys(obj).forEach(key => {
        const pVal = prev[key];
        const oVal = obj[key];
        if (Array.isArray(pVal) && Array.isArray(oVal)) {
          prev[key] = pVal.concat(...oVal);
        } else if (IsAnObject(pVal) && IsAnObject(oVal)) {
          prev[key] = mergeDeep(pVal, oVal);
        } else {
          prev[key] = oVal;
        }
      });
      return prev;
    }, {});
  };
  return mergeDeep(baseObject, overrideObject);
};
exports.DeepMergeObjects = DeepMergeObjects;
const OverrideMergeObjects = _ref2 => {
  let {
    baseObject,
    overrideObject
  } = _ref2;
  const mergeOverride = function mergeOverride() {
    for (var _len2 = arguments.length, objects = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      objects[_key2] = arguments[_key2];
    }
    return objects.reduce((prev, obj) => {
      Object.keys(obj).forEach(key => {
        const pVal = prev[key];
        const oVal = obj[key];
        if (Array.isArray(pVal) && Array.isArray(oVal)) {
          prev[key] = oVal;
        } else if (IsAnObject(pVal) && IsAnObject(oVal)) {
          prev[key] = mergeOverride(pVal, oVal);
        } else if (pVal && !oVal) {
          prev[key] = pVal;
        } else if (oVal && !pVal) {
          prev[key] = oVal;
        } else {
          prev[key] = oVal;
        }
      });
      return prev;
    }, {});
  };
  return mergeOverride(baseObject, overrideObject);
};
exports.OverrideMergeObjects = OverrideMergeObjects;
const MakeInheritanceObject = _ref3 => {
  let {
    base,
    valueOnly = false,
    baseObjectName,
    compare,
    propPath = [],
    excludePropSpread = []
  } = _ref3;
  const CreateSpreader = () => {
    if (propPath.length > 0) {
      return "...".concat(baseObjectName, ".").concat(propPath.join('.'));
    }
    return "...".concat(baseObjectName);
  };
  const RequiresSpreader = () => {
    if (valueOnly) {
      return false;
    }
    if (propPath.length > 0 && excludePropSpread.length > 0) {
      return excludePropSpread.indexOf(propPath[propPath.length - 1]) === -1;
    }
    return true;
  };

  // Start with the base spreader
  const InheritanceObjectPieces = [];
  if (RequiresSpreader()) {
    InheritanceObjectPieces.push(CreateSpreader());
  }

  // The compare object is expected to inherit all the base properties,
  // so we are only interested in finding an object that represents the differences.
  Object.entries(compare).forEach(_ref4 => {
    let [key, compareValue] = _ref4;
    // Make sure we are comparing apples to apples by stringifying them first
    // Note for this to work on objects, the keys need to be in the same order
    /* eslint-disable-next-line no-prototype-builtins */
    if (!base.hasOwnProperty(key)) {
      InheritanceObjectPieces.push(CreateCompareValueOverride(key, compareValue));
    }
    if (typeof base[key] !== 'undefined' && !ObjectsAreTheSame(base[key], compareValue)) {
      // If it is an object we need to recursively check the properties
      // For everything else it can just be returned as an override
      if (IsAnObject(compareValue)) {
        InheritanceObjectPieces.push("".concat(key, ":").concat(MakeInheritanceObject({
          base: base[key],
          baseObjectName,
          compare: compareValue,
          propPath: [...propPath, key],
          excludePropSpread
        })));
      } else {
        InheritanceObjectPieces.push(CreateCompareValueOverride(key, compareValue));
      }
    }
  });
  return "{".concat(InheritanceObjectPieces.join(', '), "}");
};
exports.MakeInheritanceObject = MakeInheritanceObject;
const UpdateNestedProperty = _ref5 => {
  let {
    jsonObject,
    propertyPath,
    newValue
  } = _ref5;
  const pathPieces = propertyPath.split('.');
  const numPieces = pathPieces.length;
  if (numPieces === 1) {
    jsonObject[propertyPath] = newValue;
    return jsonObject;
  }
  let currentBranch = jsonObject;
  pathPieces.forEach((piece, index) => {
    if (index === numPieces - 1) {
      currentBranch[piece] = newValue;
    } else if (currentBranch[piece]) {
      currentBranch = currentBranch[piece];
    }
  });
  return jsonObject;
};
exports.UpdateNestedProperty = UpdateNestedProperty;
var _default = exports.default = {
  ObjectsAreTheSame,
  IsAnObject,
  CreateCompareValueOverride,
  DeepMergeObjects,
  OverrideMergeObjects,
  MakeInheritanceObject,
  UpdateNestedProperty
};